import { PageVisibleState } from '../../metric/base-metric';
import { visibilityChangeObserver } from '../../observer/visibility-change-observer';
import type {
	BaseMetricDataWithStartAndStop,
	PerformanceEventConfig,
	ShareableGlobalConfig,
} from '../../types';
import { pageVisibleValue } from '../page-visible/value';

import { webVitalsMetricCustomTimeout } from './web-vitals-metric-custom-timeout';

export const webVitalsMetrics = async (
	config: PerformanceEventConfig,
	data: BaseMetricDataWithStartAndStop,
	globalConfig: ShareableGlobalConfig,
): Promise<{
	'pageVisible:value': boolean;
	'pageVisible:state': PageVisibleState;
}> => {
	let pageVisibleState = data.pageVisibleState;
	const setPageVisibleStateToMixed = () => {
		pageVisibleState = PageVisibleState.MIXED;
	};
	visibilityChangeObserver.subscribe(setPageVisibleStateToMixed);
	const ttciEnabled =
		globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
	const webVitalMetrics = await webVitalsMetricCustomTimeout(
		ttciEnabled,
		globalConfig.webVitals?.timeout || 30000,
	);
	visibilityChangeObserver.unsubscribe(setPageVisibleStateToMixed);
	return {
		...webVitalMetrics,
		'pageVisible:state': pageVisibleState,
		...pageVisibleValue(config, data, globalConfig),
	};
};
